<div class="esf-form-item">
  <div class="esf-check-radio">
    <input class="esf-check-radio__input esf-check-radio--check__input"
           type="checkbox"
           [formControl]="formControl"
           [id]="id"
           (change)="emitValue($event)"
           [name]="id">
    <label class="esf-check-radio__label esf-check-radio--check__label" [for]="id">{{ label }}</label>
  </div>
</div>
